@if (!loading() && settings()) {
  <div [class.toggle-off]="!value()" class="ga-toggle" (click)="toggleValue()">
    @if (!allNotifications()) {
      <label class="body-bold">
        {{ i18n.langString("allow_push_notification") }}
      </label>
    } @else {
      <label class="body-bold">
        {{ i18n.langString("allow_push_notifications") }}
      </label>
    }

    <nz-switch [ngModel]="value()"></nz-switch>
  </div>
}
